import React, { useEffect, useContext, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import DateTimeCustomizationModal from "../../Modals/dateTimeCustomizationModal/DateTimeCustomizationModal";
import DateTimeModal from "../../Modals/dateTimeModal/DateTimeModal";
import DateOptionsModal from "../../Modals/dateOptionsModal/DateOptionsModal";
import UploadEventImageModal from "../../Modals/uploadEventImageModal/UploadEventImageModal";
import AsoEbiModal from "../../Modals/asoEbiModal/AsoEbiModal";
import CashGiftModal from "../../Modals/cashGiftModal/CashGiftModal";
import EntryTicketModal from "../../Modals/entryTicketModal/EntryTicketModal";
import EventCreatedModal from "../../Modals/eventCreatedModal/EventCreatedModal";
import CustomButton from "../../components/customButton/CustomButton";
import LandmarkInput from "../../components/landmarkInput/LandmarkInput";
import Header from "../../components/header/Header";
import EventHeader from "../../components/eventHeader/EventHeader";
import {
  convertToBase64,
  uploadImageToBlob,
} from "../../helper/convertToBase64";
import { CheckIcon, DownArrowIcon } from "../../helper/icon";
import "./CreateEvent.css";
import { AuthContext } from "../../context/auth";
import {
  formatDateToLocal,
  compressImage,
  formatDateTime,
  parseLocalDateFromInput,
  formatDateForInput,
  formatTimeForEditInput,
  formatDateForBackend,
  formatTimeForBackend,
} from "../../helper/utils";

const ImagePlaceholder = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.67 18.95L7.6 15.64C8.39 15.11 9.53 15.17 10.24 15.78L10.57 16.07C11.35 16.74 12.61 16.74 13.39 16.07L17.55 12.5C18.33 11.83 19.59 11.83 20.37 12.5L22 13.9"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ErrorText = ({ error }) => {
  if (!error) return null;
  return <p className="create-event-screen-error-text">{error}</p>;
};

const CreateEventScreen = () => {
  const navigate = useNavigate();

  const { user } = useContext(AuthContext);
  const userId = user?._id;
  const location = useLocation();
  const userName = location.state || {};

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!user) {
      navigate("/");
    }
  }, [user]);

  const [eventData, setEventData] = useState({
    eventType: "",
    eventId: "",
    eventLandmark: "",
    eventLocation: "",
    inviteCode: "",
    eventTitle: "",
    multipleDates: [
      {
        subTitle: "",
        date: null,
        time: null,
        location: "",
        landmark: "",
        customAddress: "",
        landmarkCoords: undefined,
      },
    ],
    dateOption: "regular",
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: "",
    location: "",
    landmark: "",
    customAddress: "",
    description: "",
    eventImages: [],
    asoEbi: false,
    cashGift: false,
    entryFee: false,
    eventDate: null,
    eventTime: null,
    colorOfTheDay: "",
    isEventAttireCompulsory: false,
    preferredCurrency: "NGN" || "USD",
    visibility: "",
    asoEbiData: {
      asoEbiImages: [],
      refundDeadlineDate: Date | null,
      isEventAttireCompulsory: false,
    },
    cashGiftData: {},
    entryFeeData: {},
    userId: user?._id || "",
  });

  const [showEventTypeDropdown, setShowEventTypeDropdown] = useState(false);
  const [isOtherEventType, setIsOtherEventType] = useState(false);
  const [customEventType, setCustomEventType] = useState("");
  const [preferredCurrency, setPreferredCurrency] = useState("");

  const [showAdditionalDates, setShowAdditionalDates] = useState(false);
  const [showDateOptionsModal, setShowDateOptionsModal] = useState(false);
  const [showDateTimeCustomizationModal, setShowDateTimeCustomizationModal] =
    useState(false);
  const [showDateTimeModal, setShowDateTimeModal] = useState(false);
  const [isAdditionalDatesChecked, setIsAdditionalDatesChecked] =
    useState(false);
  const [isSaveClicked, setIsSaveClicked] = useState(false);
  const [showUploadEventImageModal, setShowUploadEventImageModal] =
    useState(false);
  const [selectedImages, setSelectedImages] = useState([]);

  const [showAsoEbiModal, setShowAsoEbiModal] = useState(false);
  const [asoEbiData, setAsoEbiData] = useState({
    asoEbiImages: [{ uri: "", price: "0", attireTag: "" }],
    refundDeadlineDate: null,
    isEventAttireCompulsory: false,
    colorOfTheDay: "",
  });

  const [showCashGiftModal, setShowCashGiftModal] = useState(false);
  const [showEntryTicketModal, setShowEntryTicketModal] = useState(false);

  const [validationErrors, setValidationErrors] = useState({});
  const [customAddress, setCustomAddress] = useState("");
  const [showCustomAddressField, setShowCustomAddressField] = useState(false);

  const [landmark, setLandmark] = useState("");
  const [landmarkCoords, setLandmarkCoords] = useState(null);
  const [isLocationManuallyEdited, setIsLocationManuallyEdited] =
    useState(false);
  const [isCreateEventLoading, setIsCreateEventLoading] = useState(false);

  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);
  const [showVisibilityDropdown, setShowVisibilityDropdown] = useState(false);

  const [eventInviteCode, setEventInviteCode] = useState("");
  const [eventUsherCode, setEventUsherCode] = useState("");
  const [eventResponse, setEventResponse] = useState();
  const preferredCurrencyRef = useRef(null);
  const visibilityRef = useRef(null);
  const descriptionRef = useRef(null);
  const eventTitleRef = useRef(null);
  const eventTypeRef = useRef(null);
  const eventLocationRef = useRef(null);
  const eventLandmarkRef = useRef(null);
  const eventImagesRef = useRef(null);

  useEffect(() => {
    return () => {
      selectedImages.forEach((image) => {
        if (image.uri?.startsWith("blob:")) {
          URL.revokeObjectURL(image.uri);
        }
      });
    };
  }, [selectedImages]);

  const clearDateErrorsForMode = (mode) => {
    setValidationErrors((prev) => {
      const updated = { ...prev };

      if (mode !== "regular") {
        delete updated.eventDate;
        delete updated.eventTime;
      }

      if (mode !== "startEnd") {
        delete updated.startDate;
        delete updated.endDate;
        delete updated.startTime;
      }

      if (mode !== "multiple") {
        Object.keys(updated).forEach((key) => {
          if (
            key.startsWith("dateTitle_") ||
            key.startsWith("dateDate_") ||
            key.startsWith("dateTime_") ||
            key.startsWith("dateLocation_")
          ) {
            delete updated[key];
          }
        });
      }

      delete updated.dateRequired;

      return updated;
    });
  };

  const eventTypes = [
    "Wedding",
    "Burial",
    "Birthday",
    "Conference",
    "Meet-up",
    "Others",
  ];
  const currencyOptions = [
    { value: "NGN", label: "Naira (₦)", symbol: "₦" },
    { value: "USD", label: "Dollar ($)", symbol: "$" },
  ];

  const handleCurrencySelect = (currency) => {
    setPreferredCurrency(currency);
    setEventData({ ...eventData, preferredCurrency: currency });
    setShowCurrencyDropdown(false);
    if (validationErrors.preferredCurrency) {
      setValidationErrors((prev) => ({ ...prev, preferredCurrency: "" }));
    }
  };

  const handleVisibilitySelect = (visibility) => {
    setEventData({ ...eventData, visibility });
    setShowVisibilityDropdown(false);
    if (validationErrors.visibility) {
      setValidationErrors((prev) => ({ ...prev, visibility: "" }));
    }
  };

  const dateOptionsSet1 = [
    {
      id: "multiple",
      title: "Multiple Date & Time",
      description: "My Event has multiple time, date & location",
    },
    {
      id: "startEnd",
      title: "Start & End Date",
      description: "My Event has start date and time",
    },
  ];

  const dateOptionsSet2 = [
    {
      id: "multiple",
      title: "Multiple Date & Time",
      description: "My Event has multiple time, date & location",
    },
    {
      id: "regular",
      title: "Regular Event",
      description: "A day Event, single date & time",
    },
  ];

  const dateOptionsSet3 = [
    {
      id: "regular",
      title: "Regular Event",
      description: "A day Event, single date & time",
    },
    {
      id: "startEnd",
      title: "Start & End Date",
      description: "My Event has start date and time",
    },
  ];

  const [currentOptionSet, setCurrentOptionSet] = useState([]);

  const validateEventData = (eventData) => {
    const errors = {};
    if (!eventData.eventType.trim()) errors.eventType = "Required";
    if (!eventData.eventTitle.trim()) errors.eventTitle = "Required";
    if (
      !eventData.eventLandmark &&
      !eventData.customAddress &&
      !eventData.multipleDates[0].landmark
    ) {
      errors.eventLandmark =
        "Please select a landmark address or enter a custom address";
    }
    if (!eventData.description || !eventData.description.trim()) {
      errors.description = "Required";
    }
    if (eventData.eventImages.length === 0)
      errors.eventImages = "At least one image required";

    if (!eventData.preferredCurrency) {
      errors.preferredCurrency = "Required";
    }

    if (!eventData.visibility) {
      errors.visibility = "Required";
    }

    if (!eventData.dateOption) {
      errors.dateOption = "Please select a date option";
      return { isValid: false, errors };
    }

    const hasAnyDateTime =
      (eventData.dateOption === "multiple" &&
        eventData.multipleDates?.some((d) => d.date && d.time)) ||
      (eventData.dateOption === "startEnd" &&
        eventData.startDate &&
        eventData.endDate &&
        eventData.startTime) ||
      (eventData.dateOption === "regular" &&
        eventData.eventDate &&
        eventData.eventTime);

    if (!hasAnyDateTime) {
      errors.dateRequired = "At least one date and time is required";
    }

    switch (eventData.dateOption) {
      case "multiple":
        eventData.multipleDates.forEach((entry, index) => {
          if (!entry.subTitle.trim()) errors[`dateTitle_${index}`] = "Required";
          if (!entry.date) errors[`dateDate_${index}`] = "Required";
          if (!entry.time) errors[`dateTime_${index}`] = "Required";
          if (!entry.location.trim())
            errors[`dateLocation_${index}`] = "Required";
        });
        break;

      case "startEnd":
        if (!eventData.startDate) errors.startDate = "Required";
        if (!eventData.endDate) errors.endDate = "Required";
        if (!eventData.startTime) errors.startTime = "Required";
        if (!eventData.eventLocation.trim()) errors.eventLocation = "Required";
        if (!eventData.eventLandmark && !eventData.customAddress) {
          errors.eventLandmark =
            "Please select a landmark address or enter a custom address";
        }
        break;

      case "regular":
        if (!eventData.eventDate) errors.eventDate = "Required";
        if (!eventData.eventTime) errors.eventTime = "Required";
        if (!eventData.eventLocation.trim()) errors.eventLocation = "Required";
        if (!eventData.eventLandmark && !eventData.customAddress) {
          errors.eventLandmark =
            "Please select a landmark address or enter a custom address";
        }
        break;

      default:
        if (!eventData.eventDate) errors.eventDate = "Required";
        if (!eventData.eventTime) errors.eventTime = "Required";
        if (!eventData.eventLocation.trim()) errors.eventLocation = "Required";
    }

    return { isValid: Object.keys(errors).length === 0, errors };
  };

  const handleAsoEbiImagesUpload = (images) => {
    setAsoEbiData({ ...asoEbiData, asoEbiImages: images });
  };

  const toggleAsoEbi = () => {
    const newAsoEbiState = !eventData.asoEbi;
    setEventData({
      ...eventData,
      asoEbi: newAsoEbiState,
      asoEbiData: newAsoEbiState ? asoEbiData : undefined,
    });

    if (newAsoEbiState) {
      setShowAsoEbiModal(true);
    } else {
      setAsoEbiData({ asoEbiImages: [] });
    }
  };

  const handleAsoEbiSave = (data) => {
    setAsoEbiData(data);
    setEventData({ ...eventData, asoEbiData: data ? data : undefined });
    setShowAsoEbiModal(false);
  };

  const handleEventAttireUpload = async (completeEventData, updateCallback) => {
    if (
      !completeEventData.asoEbiData ||
      !completeEventData.asoEbiData?.asoEbiImages
    )
      return;

    const updatedImages = await Promise.all(
      completeEventData.asoEbiData.asoEbiImages.map(async (asset, index) => {
        if (!asset.file) return null;

        try {
          const compressedFile = await compressImage(asset.file);

          const blobResponse = await uploadImageToBlob(
            compressedFile,
            `asoebi_${index}.jpeg`,
            "asoebi",
          );

          const blobUrl = blobResponse?.data?.Location;
          // console.log("Aso Ebi Blob URL:", blobUrl);

          if (!blobUrl)
            // throw new Error("Blob URL not found");

            return {
              uri: blobUrl,
              name: `asoebi_${index}.jpeg`,
              type: compressedFile.type || "image/jpeg",
            };
        } catch (error) {
          // console.error("Upload error:", error);
          return null;
        }
      }),
    );

    const validUpdatedImages = updatedImages.filter(Boolean);

    const updatedEventData = {
      asoEbiData: {
        ...completeEventData.asoEbiData,
        asoEbiImages: validUpdatedImages,
      },
    };
    // console.log("updated aso ebi", updatedEventData);

    updateCallback(updatedEventData);
  };

  const fieldRefs = {
    description: descriptionRef,
    eventTitle: eventTitleRef,
    eventLocation: eventLocationRef,
    eventType: eventTypeRef,
    visibility: visibilityRef,
    preferredCurrency: preferredCurrencyRef,
    eventLandmark: eventLandmarkRef,
    eventImages: eventImagesRef,
  };

  const scrollToFirstError = (errors) => {
    const firstErrorKey = Object.keys(errors)[0];
    const ref = fieldRefs[firstErrorKey];
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
      ref.current.focus({ preventScroll: true });
    }
  };

  const handleCreateEvent = async () => {
    try {
      const validation = validateEventData(eventData);
      setValidationErrors(validation.errors);
      if (!validation.isValid) {
        scrollToFirstError(validation.errors);
        setIsCreateEventLoading(false);
        return;
      }

      setIsCreateEventLoading(true);
      let updatedEventData = { ...eventData };

      if (updatedEventData.eventImages?.length > 0) {
        const uploadedEventImages = [];

        for (const asset of updatedEventData.eventImages) {
          if (!asset.file) continue;

          try {
            const fullDataUri = await convertToBase64(asset.file);
            const response = await uploadImageToBlob(
              fullDataUri,
              asset.file.name || "event_image.jpg",
              "event",
            );

            const url = response.data?.Location;

            if (url) {
              uploadedEventImages.push({
                uri: url,
                name: asset.file.name || "event_image.jpg",
                type: asset.file.type || "image/jpeg",
              });
            }
          } catch (err) {
            // console.error("Event image upload failed:", err);
            alert("Failed to upload one or more event images.");
            setIsCreateEventLoading(false);
            return;
          }
        }

        updatedEventData.eventImages = uploadedEventImages;
      }

      if (
        updatedEventData.asoEbi &&
        updatedEventData.asoEbiData?.asoEbiImages?.length > 0
      ) {
        const uploadedAsoEbiImages = [];

        for (const asset of updatedEventData.asoEbiData.asoEbiImages) {
          if (!asset.file) {
            if (asset.uri) {
              uploadedAsoEbiImages.push({
                uri: asset.uri,
                price: asset.price || "0",
                attireTag: asset.attireTag || "",
              });
            }
            continue;
          }

          try {
            const fullDataUri = await convertToBase64(asset.file);
            const response = await uploadImageToBlob(
              fullDataUri,
              asset.file.name || "asoebi.jpg",
              "aso_ebi",
            );

            const url = response.data?.Location;
            if (url) {
              uploadedAsoEbiImages.push({
                uri: url,
                price: asset.price || "0",
                attireTag: asset.attireTag || "",
              });
            }
          } catch (err) {
            // console.error("Aso Ebi upload failed:", err);
            alert("Failed to upload one or more attire images.");
            setIsCreateEventLoading(false);
            return;
          }
        }

        updatedEventData.asoEbiData = {
          ...(updatedEventData.asoEbiData || {}),

          asoEbiImages: uploadedAsoEbiImages,
        };
      }

      const completeEventData = {
        ...updatedEventData,
        landmark: landmark || customAddress,
        landmarkCoords: landmarkCoords || { latitude: 0, longitude: 0 },
        customAddress: customAddress || "",
        eventLandmark:
          updatedEventData.eventLandmark || landmark || customAddress,
        eventLocation:
          updatedEventData.eventLocation || updatedEventData.location,

        location: updatedEventData.eventLocation || updatedEventData.location,

        visibility: updatedEventData.visibility || "public",
        colorOfTheDay: updatedEventData.colorOfTheDay || "",

        cashGiftData: updatedEventData.cashGift
          ? updatedEventData.cashGiftData
          : undefined,

        entryFeeData:
          updatedEventData.entryFee && updatedEventData.entryFeeData
            ? { tickets: updatedEventData.entryFeeData }
            : undefined,

        ticketFee:
          updatedEventData.entryFee && updatedEventData.entryFeeData
            ? updatedEventData.entryFeeData
            : [],

        asoEbiData:
          updatedEventData.asoEbi && updatedEventData.asoEbiData
            ? {
                ...updatedEventData.asoEbiData,
                isEventAttireCompulsory:
                  updatedEventData.asoEbiData.isEventAttireCompulsory || false,
                refundDeadlineDate: updatedEventData.asoEbiData
                  .refundDeadlineDate
                  ? formatDateForBackend(
                      updatedEventData.asoEbiData.refundDeadlineDate,
                    )
                  : null,
              }
            : undefined,

        ticketFee:
          updatedEventData.entryFee && updatedEventData.entryFeeData
            ? updatedEventData.entryFeeData
            : [],

        eventDate: updatedEventData.eventDate
          ? formatDateForBackend(updatedEventData.eventDate)
          : null,
        eventTime: updatedEventData.eventTime
          ? formatTimeForBackend(updatedEventData.eventTime)
          : null,
        startDate: updatedEventData.startDate
          ? formatDateForBackend(new Date(updatedEventData.startDate))
          : null,
        startTime: updatedEventData.startTime
          ? formatTimeForBackend(new Date(updatedEventData.startTime))
          : null,
        endDate: updatedEventData.endDate
          ? formatDateForBackend(new Date(updatedEventData.endDate))
          : null,
        endTime: updatedEventData.endTime
          ? formatTimeForBackend(new Date(updatedEventData.endDate))
          : null,
        multipleDates: updatedEventData.multipleDates.map((dateEntry) => ({
          ...dateEntry,
          landmarkCoords: dateEntry.landmarkCoords,
          date: dateEntry.date ? formatDateForBackend(dateEntry.date) : null,
          time: dateEntry.time ? formatTimeForBackend(dateEntry.time) : null,
        })),
      };

      console.log("Creating event with data:", completeEventData);
      await createEventHandler(completeEventData);
    } catch (error) {
      console.error("Error in handleCreateEvent:", error);
      alert("Failed to create event. Please try again.");
      setIsCreateEventLoading(false);
    }
  };

  console.log(eventData);

  const handleEventImageUpload = async (completeEventData, updateCallback) => {
    const updatedImages = [];
    for (let i = 0; i < completeEventData.eventImages.length; i++) {
      const asset = completeEventData.eventImages[i];
      if (!asset.file) {
        continue;
      }

      try {
        const compressedFile = await compressImage(asset.file);
        const base64Image = await convertToBase64(compressedFile);
        const blobResponse = await uploadImageToBlob(
          compressedFile,
          `photo_${i}.jpeg`,
          "event",
        );
        // console.log("blobresponse", blobResponse);

        const blobUrl = blobResponse?.data?.Location;
        if (!blobUrl)
          // throw new Error("Missing blob URL from upload response");
          updatedImages.push({
            uri: blobUrl,
            type: asset.type,
            name: asset.name,
          });
      } catch (error) {
        alert("Upload Failed: Unable to upload the image. Try again.");
        return;
      }
    }
    updateCallback({ eventImages: updatedImages });
  };

  const createEventHandler = async (completeEventData) => {
    try {
      const response = await axios.post(
        "/event/create",
        { completeEventData },
        { headers: { "Content-Type": "application/json" } },
      );
      // console.log("Create event response:", response.data);
      setIsCreateEventLoading(false);
      setSuccessModalVisible(true);
      setEventResponse(response.data.data);
      setEventInviteCode(response.data.data.inviteCode);
      setEventUsherCode(response.data.data.usherCode);
      return response.data;
    } catch (error) {
      setIsCreateEventLoading(false);
      const message =
        error?.response?.data?.message || "Failed to create event";
      alert(`Error: ${message}`);
      // console.error("Create event error: ", error);
    }
  };

  const handleCashGiftSave = (data) => {
    setEventData({
      ...eventData,
      cashGiftData: data,
      bankDetails: data.bankDetails,
    });
    setShowCashGiftModal(false);
  };

  const handleEntryTicketSave = (ticketFeeData) => {
    setEventData({
      ...eventData,
      entryFeeData: ticketFeeData,
      ticketFee: ticketFeeData,
      isTicketMandatory: ticketFeeData.isTicketMandatory,
      ticketRefundPolicy: ticketFeeData.refundPolicy,
    });
    setShowEntryTicketModal(false);
  };

  const handleEventTypeSelect = (type) => {
    if (type === "Others") {
      setIsOtherEventType(true);
      setShowEventTypeDropdown(false);
    } else {
      setEventData({ ...eventData, eventType: type });
      setShowEventTypeDropdown(false);
      setIsOtherEventType(false);
      setCustomEventType("");
      if (validationErrors.eventType) {
        setValidationErrors((prev) => ({ ...prev, eventType: "" }));
      }
    }
  };

  const handleCustomEventTypeSubmit = () => {
    if (customEventType.trim()) {
      setEventData({ ...eventData, eventType: customEventType.trim() });
      setIsOtherEventType(false);
    }
  };

  const updateDateTime = (index, field, value) => {
    setEventData((prev) => {
      const updatedDates = [...prev.multipleDates];
      updatedDates[index] = { ...updatedDates[index], [field]: value };
      return { ...prev, multipleDates: updatedDates };
    });
  };

  const handleLandmarkChange = (text) => {
    setLandmark(text);
    setEventData((prev) => ({ ...prev, eventLandmark: text, location: text }));
    if (validationErrors.eventLandmark || validationErrors.location) {
      setValidationErrors((prev) => ({
        ...prev,
        eventLandmark: "",
        location: "",
      }));
    }
  };

  const handlePlaceSelected = (place) => {
    if (!place) {
      setLandmark("");
      setEventData((prev) => ({
        ...prev,
        eventLandmark: "",
        eventLocation: "",
      }));
      setLandmarkCoords(null);
      setIsLocationManuallyEdited(false);
      return;
    }

    setLandmark(place.address);
    setEventData((prev) => ({
      ...prev,
      eventLandmark: place.address,
      eventLocation: isLocationManuallyEdited
        ? prev.eventLocation
        : place.address,
    }));
    setLandmarkCoords(
      place.coords?.latitude != null && place.coords?.longitude != null
        ? { latitude: place.coords.latitude, longitude: place.coords.longitude }
        : null,
    );

    setValidationErrors((prev) => {
      const copy = { ...prev };
      delete copy.eventLandmark;
      delete copy.eventLocation;
      return copy;
    });
  };

  const handleEventLocationChange = (value) => {
    setIsLocationManuallyEdited(true);
    setEventData((prev) => ({ ...prev, eventLocation: value }));
    if (validationErrors.eventLocation) {
      setValidationErrors((prev) => ({ ...prev, eventLocation: "" }));
    }
  };

  const handleSelectDateOption = (optionId) => {
    setEventData({ ...eventData, dateOption: optionId });

    if (optionId === "multiple") {
      setShowDateTimeCustomizationModal(true);
      setShowAdditionalDates(true);
      setIsAdditionalDatesChecked(true);
      setEventData({
        ...eventData,
        dateOption: "multiple",
        eventDate: null,
        eventTime: null,
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
      });
    } else if (optionId === "startEnd") {
      setShowDateTimeModal(true);
      setShowAdditionalDates(true);
      setIsAdditionalDatesChecked(true);

      setEventData({
        ...eventData,
        multipleDates: [
          {
            subTitle: "",
            date: null,
            time: null,
            location: "",
            customAddress: "",
            landmark: "",
            landmarkCoords: undefined,
          },
        ],
        dateOption: "startEnd",
        eventDate: null,
        eventTime: null,
      });
    } else if (optionId === "regular") {
      setIsSaveClicked(false);
      setShowAdditionalDates(false);
      setIsAdditionalDatesChecked(false);

      setEventData({
        ...eventData,
        multipleDates: [
          {
            subTitle: "",
            date: null,
            time: null,
            location: "",
            landmark: "",
            customAddress: "",
            landmarkCoords: undefined,
          },
        ],
        dateOption: "regular",
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
      });
    }
    clearDateErrorsForMode(eventData.dateOption);
    setShowDateOptionsModal(false);
  };

  const toggleAdditionalDates = () => {
    clearDateErrorsForMode(eventData.dateOption);
    if (!isAdditionalDatesChecked) {
      if (isSaveClicked) {
        if (eventData.dateOption === "multiple") {
          setCurrentOptionSet(dateOptionsSet3);
        } else if (eventData.dateOption === "startEnd") {
          setCurrentOptionSet(dateOptionsSet2);
        } else {
          setCurrentOptionSet(dateOptionsSet1);
        }
      } else {
        setCurrentOptionSet(dateOptionsSet1);
      }
      setShowDateOptionsModal(true);
      setIsAdditionalDatesChecked(true);
    } else {
      if (isSaveClicked) {
        if (eventData.dateOption === "multiple") {
          setCurrentOptionSet(dateOptionsSet3);
        } else if (eventData.dateOption === "startEnd") {
          setCurrentOptionSet(dateOptionsSet2);
        } else {
          setCurrentOptionSet(dateOptionsSet1);
        }
        setShowDateOptionsModal(true);
      } else {
        setShowAdditionalDates(false);
        setIsAdditionalDatesChecked(false);
        setEventData({
          ...eventData,
          multipleDates: [
            {
              subTitle: "",
              date: null,
              time: null,
              location: "",
              landmark: "",
              customAddress: "",
              landmarkCoords: undefined,
            },
          ],
          dateOption: "",
          startDate: "",
          startTime: "",
          endDate: "",
          endTime: "",
        });
        setIsSaveClicked(false);
        setIsAdditionalDatesChecked(false);
      }
    }
  };

  const handleSaveDateTimeCustomization = (entries) => {
    setEventData((prev) => ({ ...prev, multipleDates: entries }));
    setShowDateTimeCustomizationModal(false);
    setIsSaveClicked(true);
  };

  const handleDateTimeSave = (dateTimeData) => {
    setEventData((prev) => ({
      ...prev,
      startDate: dateTimeData.startDate.toISOString(),
      endDate: dateTimeData.endDate.toISOString(),
      startTime: dateTimeData.startTime.toISOString(),
    }));

    setShowDateTimeModal(false);
    setIsSaveClicked(true);
  };

  const toggleCashGift = () => {
    const newCashGiftState = !eventData.cashGift;
    setEventData({
      ...eventData,
      cashGift: newCashGiftState,
    });

    if (newCashGiftState) {
      // setShowCashGiftModal(true);
    }
  };

  const toggleEntryFee = () => {
    const newEntryFeeState = !eventData.entryFee;
    setEventData({
      ...eventData,
      entryFee: newEntryFeeState,
      entryFeeData: newEntryFeeState ? eventData.entryFeeData : undefined,
    });

    if (newEntryFeeState) {
      setShowEntryTicketModal(true);
    }
  };

  const handleDefaultDateChange = (date) => {
    setEventData({ ...eventData, eventDate: date });
    if (validationErrors.eventDate) {
      setValidationErrors((prev) => ({ ...prev, eventDate: "" }));
    }
    if (validationErrors.dateRequired) {
      setValidationErrors((prev) => ({ ...prev, dateRequired: "" }));
    }
  };

  const handleDefaultTimeChange = (time) => {
    setEventData({ ...eventData, eventTime: time });
    if (validationErrors.eventTime) {
      setValidationErrors((prev) => ({ ...prev, eventTime: "" }));
    }
    if (validationErrors.dateRequired) {
      setValidationErrors((prev) => ({ ...prev, dateRequired: "" }));
    }
  };

  const handleStartDateChange = (date) => {
    setEventData({ ...eventData, startDate: date.toISOString() });
    setValidationErrors((prev) => ({
      ...prev,
      startDate: "",
      dateRequired: "",
    }));
  };

  const handleEndDateChange = (date) => {
    setEventData({ ...eventData, endDate: date.toISOString() });
    setValidationErrors((prev) => ({ ...prev, endDate: "", dateRequired: "" }));
  };

  const handleStartTimeChange = (time) => {
    setEventData({ ...eventData, startTime: time.toISOString() });
  };

  const handleImagesSubmit = (images) => {
    setSelectedImages(images);
    setEventData({
      ...eventData,
      eventImages: images.map((image) => ({
        uri: image.uri,
        type: image.type,
        name: image.name,
        file: image.file,
      })),
    });
  };

  const removeSelectedImage = (index) => {
    const newImages = [...selectedImages];
    newImages.splice(index, 1);
    setSelectedImages(newImages);
    setEventData({
      ...eventData,
      eventImages: newImages.length > 0 ? newImages : [],
    });

    if (newImages.length > 0 && validationErrors.eventImages) {
      setValidationErrors((prev) => ({ ...prev, eventImages: "" }));
    }
  };

  const renderImagePreviews = () => {
    if (selectedImages.length === 0) return null;
    if (validationErrors.eventImages) {
      setValidationErrors((prev) => ({ ...prev, eventImages: "" }));
    }
    return (
      <div className="create-event-screen-image-previews-container">
        {selectedImages.map((image, index) => (
          <div
            key={index}
            className="create-event-screen-image-preview-wrapper"
          >
            <img
              src={image.uri || "/placeholder.svg"}
              alt={`Preview ${index}`}
              className="create-event-screen-image-preview"
            />
            <button
              className="create-event-screen-remove-preview-button"
              onClick={() => removeSelectedImage(index)}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        ))}
      </div>
    );
  };

  const renderDateTimeSection = () => {
    if (!isSaveClicked) return null;

    if (eventData.dateOption === "multiple") {
      return (
        <>
          {eventData.multipleDates.map((entry, index) => (
            <div
              key={index}
              className="create-event-screen-date-time-entry-container"
            >
              <label className="create-event-screen-label">Title</label>
              <div className="create-event-screen-input-container">
                <input
                  ref={eventTitleRef}
                  className="create-event-screen-input"
                  placeholder="Enter Sub Event Title"
                  value={entry.subTitle || ""}
                  onChange={(e) => {
                    updateDateTime(index, "subTitle", e.target.value);

                    const key = `dateTitle_${index}`;
                    if (validationErrors[key]) {
                      setValidationErrors((prev) => ({ ...prev, [key]: "" }));
                    }
                  }}
                />
              </div>
              <ErrorText error={validationErrors[`dateTitle_${index}`]} />

              <label className="label">Address</label>
              {/* <LandmarkInput
                value={eventData.eventLandmark}
                onChangeText={handleLandmarkChange}
                onPlaceSelected={handlePlaceSelected}
                placeholder="Type your address here..."
              /> */}
              <LandmarkInput
                value={entry.landmark || ""}
                onChangeText={(text) => {
                  updateDateTime(index, "landmark", text);
                }}
                onPlaceSelected={(place) => {
                  if (!place) {
                    updateDateTime(index, "landmark", "");
                    updateDateTime(index, "landmarkCoords", null);
                    return;
                  }
                  updateDateTime(index, "landmark", place.address);
                  updateDateTime(
                    index,
                    "landmarkCoords",
                    place.coords?.latitude != null &&
                      place.coords?.longitude != null
                      ? {
                          latitude: place.coords.latitude,
                          longitude: place.coords.longitude,
                        }
                      : null,
                  );
                }}
                placeholder="Type your address here..."
              />

              <ErrorText error={validationErrors[`dateLandmark_${index}`]} />

              <label className="create-event-screen-label">
                Full Address Description
              </label>
              <div className="create-event-screen-input-container">
                <input
                  className="create-event-screen-input"
                  placeholder="Enter Event Location Venue"
                  value={entry.location}
                  onChange={(e) => {
                    updateDateTime(index, "location", e.target.value);
                    const key = `dateLocation_${index}`;
                    if (validationErrors[key]) {
                      setValidationErrors((prev) => ({ ...prev, [key]: "" }));
                    }
                  }}
                />
                <div className="create-event-screen-location-icon">
                  <i className="fas fa-map-pin"></i>
                </div>
              </div>
              <ErrorText error={validationErrors[`dateLocation_${index}`]} />

              <div className="create-event-screen-date-time-container">
                <div className="create-event-screen-date-time-column">
                  <div className="create-event-screen-date-picker-wrapper">
                    <label className="create-event-screen-label">Date</label>
                    <input
                      type="date"
                      className="create-event-screen-date-picker"
                      value={entry.date ? formatDateForInput(entry.date) : ""}
                      onClick={(e) => e.target.showPicker()}
                      onChange={(e) => {
                        updateDateTime(
                          index,
                          "date",
                          parseLocalDateFromInput(e.target.value),
                        );
                        const key = `dateDate_${index}`;
                        if (validationErrors[key]) {
                          setValidationErrors((prev) => ({
                            ...prev,
                            [key]: "",
                          }));
                        }
                        if (validationErrors.dateRequired) {
                          setValidationErrors((prev) => ({
                            ...prev,
                            dateRequired: "",
                          }));
                        }
                      }}
                    />
                  </div>
                  <ErrorText error={validationErrors[`dateDate_${index}`]} />
                </div>
                <div className="create-event-screen-date-time-column">
                  <div className="create-event-screen-time-picker-wrapper">
                    <label className="create-event-screen-label">Time</label>
                    <input
                      type="time"
                      className="create-event-screen-time-picker"
                      value={
                        entry.time ? formatTimeForEditInput(entry.time) : ""
                      }
                      onChange={(e) => {
                        const [hours, minutes] = e.target.value.split(":");
                        const date = new Date();
                        date.setHours(Number.parseInt(hours, 10));
                        date.setMinutes(Number.parseInt(minutes, 10));
                        date.setSeconds(0);
                        date.setMilliseconds(0);
                        updateDateTime(index, "time", date);

                        const key = `dateTime_${index}`;
                        if (validationErrors[key]) {
                          setValidationErrors((prev) => ({
                            ...prev,
                            [key]: "",
                          }));
                        }
                        if (validationErrors.dateRequired) {
                          setValidationErrors((prev) => ({
                            ...prev,
                            dateRequired: "",
                          }));
                        }
                      }}
                    />
                  </div>
                  <ErrorText error={validationErrors[`dateTime_${index}`]} />
                </div>
              </div>

              <button
                className="create-event-screen-remove-button"
                onClick={() => {
                  if (
                    window.confirm("Are you sure you want to remove this date?")
                  ) {
                    const updatedDates = eventData.multipleDates.filter(
                      (_, i) => i !== index,
                    );

                    const isEmpty = updatedDates.length === 0;

                    setEventData({
                      ...eventData,
                      multipleDates: updatedDates,
                      dateOption:
                        updatedDates.length === 0
                          ? "single"
                          : eventData.dateOption,
                    });
                    if (isEmpty) {
                      setIsAdditionalDatesChecked(false);
                    }
                  }
                }}
              >
                Remove
              </button>
            </div>
          ))}
        </>
      );
    }

    if (eventData.dateOption === "startEnd") {
      return (
        <>
          <div className="create-event-screen-date-container">
            <div className="create-event-screen-date-section">
              <div className="create-event-screen-date-picker-wrapper">
                <label className="create-event-screen-label">Start Date</label>
                <input
                  type="date"
                  className="create-event-screen-date-picker"
                  value={
                    eventData.startDate
                      ? formatDateForInput(new Date(eventData.startDate))
                      : ""
                  }
                  onClick={(e) => e.target.showPicker()}
                  onChange={(e) =>
                    handleStartDateChange(
                      parseLocalDateFromInput(e.target.value),
                    )
                  }
                />
              </div>
              <ErrorText error={validationErrors.startDate} />
            </div>

            <div className="create-event-screen-date-section">
              <div className="create-event-screen-date-picker-wrapper">
                <label className="create-event-screen-label">End Date</label>
                <input
                  type="date"
                  className="create-event-screen-date-picker"
                  value={
                    eventData.endDate
                      ? formatDateForInput(new Date(eventData.endDate))
                      : ""
                  }
                  onClick={(e) => e.target.showPicker()}
                  onChange={(e) =>
                    handleEndDateChange(parseLocalDateFromInput(e.target.value))
                  }
                  min={
                    eventData.startDate
                      ? formatDateForInput(new Date(eventData.startDate))
                      : ""
                  }
                />
              </div>
              <ErrorText error={validationErrors.endDate} />
            </div>
          </div>

          <div className="create-event-screen-time-section">
            <div className="create-event-screen-time-picker-wrapper">
              <label className="create-event-screen-label">Time</label>
              <input
                type="time"
                className="create-event-screen-time-picker"
                value={
                  eventData.startTime
                    ? formatTimeForEditInput(new Date(eventData.startTime))
                    : ""
                }
                onChange={(e) => {
                  const [hours, minutes] = e.target.value.split(":");
                  const date = new Date();
                  date.setHours(Number.parseInt(hours, 10));
                  date.setMinutes(Number.parseInt(minutes, 10));
                  date.setSeconds(0);
                  date.setMilliseconds(0);
                  handleStartTimeChange(date);
                }}
              />
            </div>
            <ErrorText error={validationErrors.startTime} />
          </div>

          <label className="create-event-screen-label">Address</label>

          {!showCustomAddressField && (
            <LandmarkInput
              value={eventData.eventLandmark}
              onChangeText={handleLandmarkChange}
              onPlaceSelected={handlePlaceSelected}
              placeholder="Type your address here..."
            />
          )}

          {showCustomAddressField && (
            <input
              className="create-event-screen-input-field"
              value={customAddress}
              onChange={(e) => {
                const value = e.target.value;

                setCustomAddress(value);

                setEventData((prev) => ({
                  ...prev,
                  eventLandmark: value,
                  customAddress: value,
                  landmarkCoords: null,
                }));
              }}
              placeholder="Enter custom address"
            />
          )}

          <button
            className="create-event-screen-custom-address-button"
            onClick={() => {
              setShowCustomAddressField(!showCustomAddressField);

              if (!showCustomAddressField) {
                setEventData({
                  ...eventData,
                  eventLandmark: customAddress,
                  landmarkCoords: null,
                });
              } else {
                setEventData({
                  ...eventData,
                  eventLandmark: landmark,
                  landmarkCoords: landmarkCoords,
                });
              }
            }}
          >
            {showCustomAddressField ? "Use Google Maps" : "Use Custom Address"}
          </button>

          <p className="create-event-screen-helper-text">
            Please enter a full and complete address, including street, city,
            state, and ZIP code.
          </p>

          <label className="create-event-screen-label">
            Full Address Description
          </label>
          <div className="create-event-screen-location-input">
            <input
              className={`create-event-screen-location-input-text ${
                validationErrors.eventLocation
                  ? "create-event-screen-input-error"
                  : ""
              }`}
              placeholder="Enter Event Location Venue"
              value={eventData.eventLocation}
              onChange={(e) => handleEventLocationChange(e.target.value)}
            />
            <i className="fas fa-location-arrow"></i>
          </div>
          <ErrorText error={validationErrors.eventLocation} />
        </>
      );
    }

    return null;
  };

  const shouldShowDefaultFields =
    !isSaveClicked ||
    (eventData.dateOption !== "multiple" &&
      eventData.dateOption !== "startEnd");

  const shouldShowDefaultLocation = shouldShowDefaultFields;

  const handleProceed = () => {
    setSuccessModalVisible(false);
    navigate("/home/host");
  };

  const handleCloseSuccessModal = async () => {
    setSuccessModalVisible(false);
    navigate("/home/host");
  };

  return (
    <div className="create-event-screen-page">
      <Header />

      <div className="create-event-screen-header">
        <EventHeader
          title="Create Event"
          showBackButton={false}
          showStatus={false}
          showDate={false}
        />
      </div>

      <div className="create-event-screen-container">
        {isCreateEventLoading && (
          <div className="create-event-screen-overlay">
            <div className="create-event-screen-spinner"></div>
          </div>
        )}
        <div className="content">
          <div className="create-event-screen-event-type-container">
            <label ref={eventTypeRef} className="create-event-screen-label">
              Event Type <span className="create-event-screen-required">*</span>
            </label>
            {isOtherEventType ? (
              <div className="create-event-screen-custom-event-type-container">
                <input
                  className={`create-event-screen-custom-event-type-input ${
                    validationErrors.eventType
                      ? "create-event-screen-input-error"
                      : ""
                  }`}
                  placeholder="Enter your event type"
                  value={customEventType}
                  onChange={(e) => {
                    setCustomEventType(e.target.value);
                    if (validationErrors.eventType) {
                      setValidationErrors((prev) => ({
                        ...prev,
                        eventType: "",
                      }));
                    }
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      handleCustomEventTypeSubmit();
                    }
                  }}
                />
                <button
                  className="create-event-screen-custom-event-type-submit-button"
                  onClick={handleCustomEventTypeSubmit}
                >
                  Submit
                </button>
              </div>
            ) : (
              <div className="create-event-screen-dropdown-container">
                <button
                  className={`create-event-screen-dropdown-button ${
                    validationErrors.eventType
                      ? "create-event-screen-input-error"
                      : ""
                  }`}
                  onClick={() =>
                    setShowEventTypeDropdown(!showEventTypeDropdown)
                  }
                >
                  <span>{eventData.eventType || "Select Event Type"}</span>
                  <DownArrowIcon />
                </button>

                {showEventTypeDropdown && (
                  <div className="create-event-screen-dropdown">
                    {eventTypes.map((type) => (
                      <div
                        key={type}
                        className="create-event-screen-dropdown-item"
                        onClick={() => handleEventTypeSelect(type)}
                      >
                        {type}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            <ErrorText error={validationErrors.eventType} />
          </div>

          <label className="create-event-screen-label">
            Event Title <span className="create-event-screen-required">*</span>
          </label>
          <input
            ref={eventTitleRef}
            data-error="eventTitle"
            className={`create-event-screen-input ${
              validationErrors.eventTitle
                ? "create-event-screen-input-error"
                : ""
            }`}
            placeholder="Enter Event Title"
            value={eventData.eventTitle}
            onChange={(e) => {
              setEventData({ ...eventData, eventTitle: e.target.value });
              if (validationErrors.eventTitle) {
                setValidationErrors((prev) => ({ ...prev, eventTitle: "" }));
              }
            }}
          />
          <ErrorText error={validationErrors.eventTitle} />
          <p className="create-event-screen-helper-text">
            Event title could be the event hashtag and event name such as
            Wedding, Naming ceremony etc
          </p>

          {renderDateTimeSection()}

          {shouldShowDefaultFields && (
            <div className="create-event-screen-default-date-time-container">
              <div className="create-event-screen-date-time-container">
                <div className="create-event-screen-date-time-column">
                  <div className="create-event-screen-date-picker-wrapper">
                    <label className="create-event-screen-label">Date</label>
                    <input
                      data-error="date"
                      type="date"
                      className="create-event-screen-date-picker"
                      value={
                        eventData.eventDate
                          ? formatDateForInput(eventData.eventDate)
                          : ""
                      }
                      onClick={(e) => e.target.showPicker()}
                      onChange={(e) =>
                        handleDefaultDateChange(
                          parseLocalDateFromInput(e.target.value),
                        )
                      }
                    />
                  </div>
                  <ErrorText error={validationErrors.eventDate} />
                </div>

                <div className="create-event-screen-date-time-column">
                  <div className="create-event-screen-time-picker-wrapper">
                    <label className="create-event-screen-label">Time</label>
                    <input
                      data-error="time"
                      type="time"
                      className="create-event-screen-time-picker"
                      value={
                        eventData.eventTime
                          ? formatTimeForEditInput(eventData.eventTime)
                          : ""
                      }
                      onClick={(e) => e.target.showPicker()}
                      onChange={(e) => {
                        const [hours, minutes] = e.target.value.split(":");
                        const date = new Date();
                        date.setHours(Number.parseInt(hours, 10));
                        date.setMinutes(Number.parseInt(minutes, 10));
                        date.setSeconds(0);
                        date.setMilliseconds(0);
                        handleDefaultTimeChange(date);
                      }}
                    />
                  </div>
                  <ErrorText error={validationErrors.eventTime} />
                </div>
              </div>
            </div>
          )}

          <div
            className="create-event-screen-checkbox-row"
            onClick={toggleAdditionalDates}
          >
            <div className="create-event-screen-checkbox">
              {isAdditionalDatesChecked && <CheckIcon />}
            </div>
            <span className="create-event-screen-checkbox-label">
              Additional Date & Time
            </span>
          </div>
          <ErrorText error={validationErrors.dateRequired} />

          {shouldShowDefaultLocation && (
            <>
              <label
                ref={eventLandmarkRef}
                className="create-event-screen-label"
              >
                Address<span className="create-event-screen-required">*</span>
              </label>

              {!showCustomAddressField && (
                <LandmarkInput
                  data-error="address"
                  value={eventData.eventLandmark}
                  onChangeText={handleLandmarkChange}
                  onPlaceSelected={handlePlaceSelected}
                  placeholder="Type your address here..."
                />
              )}

              {showCustomAddressField && (
                <input
                  data-error="customAddress"
                  className="create-event-screen-input-field"
                  value={customAddress}
                  onChange={(e) => {
                    const value = e.target.value;

                    setCustomAddress(value);

                    setEventData((prev) => ({
                      ...prev,
                      eventLandmark: value,
                      customAddress: value,
                      landmarkCoords: null,
                    }));
                  }}
                  placeholder="Enter custom address"
                />
              )}

              <button
                className="create-event-screen-custom-address-button"
                onClick={() => {
                  setShowCustomAddressField(!showCustomAddressField);
                  if (showCustomAddressField) {
                    setLandmark(landmark);
                    setLandmarkCoords(landmarkCoords);
                    setEventData({
                      ...eventData,
                      landmark: landmark,
                      landmarkCoords: landmarkCoords,
                    });
                  } else {
                    setLandmark(customAddress);
                    setLandmarkCoords(null);
                    setEventData({
                      ...eventData,
                      landmark: customAddress,
                      landmarkCoords: null,
                    });
                  }
                }}
              >
                {showCustomAddressField
                  ? "Use Google Maps"
                  : "Use Custom Address"}
              </button>
              <ErrorText error={validationErrors.eventLandmark} />

              <p className="create-event-screen-helper-text">
                Please enter a full and complete address, including all
                necessary details, like the street name, city, state, and ZIP
                code
              </p>
              <label className="create-event-screen-label">
                Full Address Description{" "}
                <span className="create-event-screen-required">*</span>
              </label>
              <textarea
                data-error="fullAddressDescription"
                className={`create-event-screen-text-area ${
                  validationErrors.eventLocation
                    ? "create-event-screen-input-error"
                    : ""
                }`}
                placeholder="Describe the address in full..."
                value={eventData.eventLocation}
                onFocus={() => {
                  if (validationErrors.eventLocation) {
                    setValidationErrors((prev) => {
                      const copy = { ...prev };
                      delete copy.eventLocation;
                      return copy;
                    });
                  }
                }}
                onChange={(e) => {
                  handleEventLocationChange(e.target.value);
                }}
              />
            </>
          )}

          <label className="create-event-screen-label">
            Additional Event Details{" "}
            <span className="create-event-screen-required">*</span>
          </label>
          <textarea
            ref={descriptionRef}
            data-error="additionalDetails"
            className={`create-event-screen-text-area ${
              validationErrors.description
                ? "create-event-screen-input-error"
                : ""
            }`}
            placeholder="Enter a description..."
            value={eventData.description}
            onFocus={() => {
              if (validationErrors.description) {
                setValidationErrors((prev) => {
                  const copy = { ...prev };
                  delete copy.description;
                  return copy;
                });
              }
            }}
            onChange={(e) => {
              const value = e.target.value;

              setEventData({ ...eventData, description: value });

              if (validationErrors.description && value.trim()) {
                setValidationErrors((prev) => {
                  const copy = { ...prev };
                  delete copy.description;
                  return copy;
                });
              }
            }}
          />
          <ErrorText error={validationErrors.description} />

          <label ref={eventImagesRef} className="create-event-screen-label">
            Upload Image attachment{" "}
            <span className="create-event-screen-required">*</span>
          </label>
          <p className="create-event-screen-image-helper-text">
            Select and upload an image or a banner for the event, max image size
            should be 2mb
          </p>
          <ErrorText error={validationErrors.eventImages} />

          {renderImagePreviews()}

          <button
            onClick={() => setShowUploadEventImageModal(true)}
            className="create-event-screen-select-file-button"
          >
            <ImagePlaceholder />
            <span className="create-event-screen-select-file-text">
              {selectedImages.length > 0 ? "Replace Images" : "Select Images"}
            </span>
          </button>
          <div className="currency-container" ref={preferredCurrencyRef}>
            <div className="label-with-tooltip">
              <span className="create-event-screen-label">
                Preferred Payment Currency{" "}
                <span className="create-event-screen-required">*</span>
              </span>
              <div className="tooltip-icon"></div>
            </div>

            <span className="create-event-screen-helper-text">
              Kindly select the payment currency you want your guests to use. If
              you choose Naira, guests can pay using Naira accounts. If you
              choose Dollar, guests can pay using Dollar accounts.
            </span>

            <div
              ref={preferredCurrencyRef}
              className={`create-event-screen-dropdown-button ${
                validationErrors.preferredCurrency
                  ? "create-event-screen-input-error"
                  : ""
              }`}
              onClick={() => setShowCurrencyDropdown(!showCurrencyDropdown)}
            >
              <span
                className={
                  preferredCurrency
                    ? "create-event-screen-currency-selected-text"
                    : "create-event-screen-currency-placeholder-text"
                }
              >
                {preferredCurrency
                  ? currencyOptions.find((c) => c.value === preferredCurrency)
                      ?.label
                  : "Select Payment Currency"}
              </span>
              <DownArrowIcon />
            </div>

            {showCurrencyDropdown && (
              <div className="create-event-screen-currency-dropdown">
                {currencyOptions.map((option) => (
                  <div
                    key={option.value}
                    className="create-event-screen-currency-dropdown-item"
                    onClick={() => handleCurrencySelect(option.value)}
                  >
                    <span className="create-event-screen-currency-symbol">
                      {option.symbol}
                    </span>
                    <span className="create-event-screen-currency-dropdown-item-text">
                      {option.label}
                    </span>
                  </div>
                ))}
              </div>
            )}

            <ErrorText error={validationErrors.preferredCurrency} />
          </div>

          <div
            className="create-event-screen-visibility-container"
            ref={visibilityRef}
            collapsable={false}
          >
            <label className="create-event-screen-label">
              Event Visibility{" "}
              <span className="create-event-screen-required">*</span>
            </label>
            <div className="create-event-screen-helper-text">
              Choose whether this event should be publicly visible or private.
              Public events can be discovered by anyone, while private events
              require an invite code to access.
            </div>

            <div
              ref={visibilityRef}
              className={`create-event-screen-dropdown-button ${
                validationErrors.visibility
                  ? "create-event-screen-input-error"
                  : ""
              }`}
              onClick={() => setShowVisibilityDropdown(!showVisibilityDropdown)}
            >
              {!eventData.visibility ? (
                <>
                  <span className="create-event-screen-visibility-placeholder-text">
                    Select Event Visibility
                  </span>
                  <DownArrowIcon />
                </>
              ) : (
                <>
                  <div className="create-event-screen-visibility-button-content">
                    <span className="create-event-screen-visibility-icon">
                      {eventData.visibility === "public" ? "🌐" : "🔒"}
                    </span>
                    <div className="create-event-screen-visibility-text-container">
                      <span className="create-event-screen-visibility-selected-text">
                        {eventData.visibility === "public"
                          ? "Public Event"
                          : "Private Event"}
                      </span>
                      <span className="create-event-screen-visibility-description">
                        {eventData.visibility === "public"
                          ? "Anyone can view and access this event"
                          : "Only accessible with an invite code"}
                      </span>
                    </div>
                  </div>
                  <DownArrowIcon />
                </>
              )}
            </div>

            {showVisibilityDropdown && (
              <div className="create-event-screen-visibility-dropdown">
                <div
                  className={`create-event-screen-visibility-dropdown-item ${
                    eventData.visibility === "public"
                      ? "create-event-screen-visibility-selected"
                      : ""
                  }`}
                  onClick={() => handleVisibilitySelect("public")}
                >
                  <span className="create-event-screen-visibility-dropdown-icon">
                    🌐
                  </span>
                  <div className="create-event-screen-visibility-dropdown-text">
                    <span className="create-event-screen-visibility-dropdown-label">
                      Public Event
                    </span>
                    <span className="create-event-screen-visibility-dropdown-description">
                      Anyone can view and access this event
                    </span>
                  </div>
                  {eventData.visibility === "public" && (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                        fill="#0e6a36"
                      />
                    </svg>
                  )}
                </div>

                <div
                  className={`create-event-screen-visibility-dropdown-item ${
                    eventData.visibility === "private"
                      ? "create-event-screen-visibility-selected"
                      : ""
                  }`}
                  onClick={() => handleVisibilitySelect("private")}
                >
                  <span className="create-event-screen-visibility-dropdown-icon">
                    🔒
                  </span>
                  <div className="create-event-screen-visibility-dropdown-text">
                    <span className="create-event-screen-visibility-dropdown-label">
                      Private Event
                    </span>
                    <span className="create-event-screen-visibility-dropdown-description">
                      Only accessible with an invite code
                    </span>
                  </div>
                  {eventData.visibility === "private" && (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                        fill="#0e6a36"
                      />
                    </svg>
                  )}
                </div>
              </div>
            )}

            <ErrorText error={validationErrors.visibility} />
          </div>

          <div className="create-event-screen-colors-container">
            <label className="create-event-screen-label">
              Color(s) of the Day
            </label>
            <input
              data-error="colorOfTheDay"
              className="create-event-screen-input-field"
              value={eventData.colorOfTheDay}
              onChange={(e) =>
                setEventData({ ...eventData, colorOfTheDay: e.target.value })
              }
              placeholder="e.g. Gold and White"
            />
          </div>

          <div
            className="create-event-screen-checkbox-row"
            onClick={toggleAsoEbi}
          >
            <div className="create-event-screen-checkbox">
              {eventData.asoEbi && <CheckIcon />}
            </div>
            <span className="create-event-screen-checkbox-label">
              Event Attire
            </span>
          </div>

          <p className="create-event-screen-feature-description">
            Activate event attire to allow invited guests to pay for aso ebi,
            fila, gele, customized cloths & cap directly through the app. You
            set the terms for collection and refunds.
          </p>

          {eventData.asoEbi && (
            <button
              className="create-event-screen-edit-aso-ebi-button"
              onClick={() => setShowAsoEbiModal(true)}
            >
              {asoEbiData.asoEbiImages.length > 0
                ? "Edit Aso Ebi Details"
                : "Add Aso Ebi Details"}
            </button>
          )}

          <div
            className="create-event-screen-checkbox-row"
            onClick={toggleCashGift}
          >
            <div className="create-event-screen-checkbox">
              {eventData.cashGift && <CheckIcon />}
            </div>
            <span className="create-event-screen-checkbox-label">
              Cash Gift
            </span>
          </div>

          <p className="create-event-screen-feature-description">
            Activate Cash Gift and let guests show their support for your event
            with a monetary contribution, easily made through the app. You set
            the rules for collection and refunds.
          </p>

          <div
            className="create-event-screen-checkbox-row"
            onClick={toggleEntryFee}
          >
            <div className="create-event-screen-checkbox">
              {eventData.entryFee && <CheckIcon />}
            </div>
            <span className="create-event-screen-checkbox-label">
              Ticket (Entry Fee)
            </span>
          </div>

          <p className="create-event-screen-feature-description">
            Activate Gate Fee and let guests pay an entry fee to attend your
            event. You set the rules for collection and refunds.
          </p>

          {eventData.entryFee && (
            <button
              className="create-event-screen-edit-aso-ebi-button"
              onClick={() => setShowEntryTicketModal(true)}
            >
              {eventData.entryFeeData
                ? "Edit Entry Ticket Details"
                : "Add Entry Ticket Details"}
            </button>
          )}

          <CustomButton
            text="Create Event"
            onClick={handleCreateEvent}
            backgroundColor="#006400"
            fontSize={16}
            className="create-event-screen-create-button"
            isLoading={isCreateEventLoading}
            isDisabled={isCreateEventLoading}
          />
        </div>

        <DateOptionsModal
          visible={showDateOptionsModal}
          onClose={() => {
            setShowDateOptionsModal(false);
            if (!isSaveClicked && !eventData.dateOption) {
              setIsAdditionalDatesChecked(false);
            }
          }}
          onSelectOption={handleSelectDateOption}
          options={currentOptionSet}
          title="Additional Date & Time"
          subtitle="Select the best option that fits your event type"
        />

        <DateTimeCustomizationModal
          visible={showDateTimeCustomizationModal}
          onClose={() => setShowDateTimeCustomizationModal(false)}
          onSave={handleSaveDateTimeCustomization}
          initialEntries={eventData.multipleDates}
        />

        <DateTimeModal
          visible={showDateTimeModal}
          onClose={() => setShowDateTimeModal(false)}
          onSave={handleDateTimeSave}
          initialValues={{
            startDate: eventData.startDate
              ? new Date(eventData.startDate)
              : undefined,
            endDate: eventData.endDate
              ? new Date(eventData.endDate)
              : undefined,
            startTime: eventData.startTime
              ? new Date(eventData.startTime)
              : undefined,
          }}
          errors={{
            startDate: validationErrors.startDate,
            endDate: validationErrors.endDate,
            startTime: validationErrors.startTime,
          }}
        />

        <UploadEventImageModal
          visible={showUploadEventImageModal}
          onClose={() => setShowUploadEventImageModal(false)}
          onSubmit={handleImagesSubmit}
          maxImages={4}
          title="Upload Event Image Attachment"
          subtitle="Select and upload a clear image of the event card, invite card or banner on each card."
          preferredCurrency={preferredCurrency}
        />

        <AsoEbiModal
          visible={showAsoEbiModal}
          onClose={() => setShowAsoEbiModal(false)}
          onImageUpload={handleAsoEbiImagesUpload}
          onSave={handleAsoEbiSave}
          initialImages={asoEbiData.asoEbiImages}
          initialRefundPolicy={asoEbiData.refundDeadlineDate}
          isEventAttireCompulsory={!!asoEbiData.isEventAttireCompulsory}
          preferredCurrency={eventData.preferredCurrency}
        />

        <CashGiftModal
          visible={showCashGiftModal}
          onClose={() => setShowCashGiftModal(false)}
          onSubmit={(data) => {
            setEventData({
              ...eventData,
              cashGiftData: data,
              bankDetails: data.bankDetails,
            });
          }}
          initialBankDetails={eventData?.bankDetails ?? null}
        />

        <EntryTicketModal
          visible={showEntryTicketModal}
          onClose={() => setShowEntryTicketModal(false)}
          onSubmit={handleEntryTicketSave}
          initialBankDetails={eventData?.bankDetails ?? null}
          initialTickets={eventData?.entryFeeData ?? eventData?.ticketFee ?? []}
          initialRefundPolicy={eventData?.ticketRefundPolicy ?? ""}
          preferredCurrency={eventData?.preferredCurrency}
        />

        <EventCreatedModal
          visible={successModalVisible}
          onClose={handleCloseSuccessModal}
          eventData={eventResponse}
          onShare={handleProceed}
          title="NimbleBash Created"
          description="Your NimbleBash invite is ready! Share the link with your guests and let the celebration begin!!!🎉🎉🎉🎉🎉"
          imagePath="/images/verified-image.png"
        />
      </div>
    </div>
  );
};

export default CreateEventScreen;
